'use client'

import { Button, ButtonSize, ButtonVariant, Icon } from '@graftcode/design-system'

import type { PageTitleProps } from './PageTitle.types'

import styles from './PageTitle.module.scss'

function cx(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(' ')
}

export function PageTitle({
  title,
  counter,
  description,
  showReloadButton = false,
  onReloadClick,
  reloadDisabled = false,
  actionButtonLabel,
  actionButtonIcon = Icon.AddFilled,
  actionButtonVariant = ButtonVariant.Secondary,
  actionButtonDisabled = false,
  onActionClick,
  className,
  afterTitle,
}: PageTitleProps) {
  const isExtended = Boolean(description || showReloadButton || actionButtonLabel)

  if (!isExtended) {
    return (
      <div className={cx(styles.inlineWrapper, className)}>
        <h1 className={styles.title}>{title}</h1>
        {counter != null ? <span className={styles.counter}>({counter})</span> : null}
        {afterTitle}
      </div>
    )
  }

  return (
    <div className={cx(styles.wrapper, className)}>
      <div className={styles.leftSection}>
        <div className={styles.titleRow}>
          <h1 className={styles.title}>{title}</h1>
          {counter != null ? <span className={styles.counter}>({counter})</span> : null}
          {afterTitle}
          {showReloadButton ? (
            <Button
              weight="semibold"
              size={ButtonSize.S}
              variant={ButtonVariant.Ghost}
              iconOnly
              icon={Icon.ArrowClockwiseRegular}
              onClick={onReloadClick}
              disabled={reloadDisabled}
              aria-label="Reload"
              className={styles.reloadButton}
            />
          ) : null}
        </div>

        {description ? <p className={styles.description}>{description}</p> : null}
      </div>

      {actionButtonLabel ? (
        <Button
          className={styles.actionButton}
          variant={actionButtonVariant}
          size={ButtonSize.L}
          text={actionButtonLabel}
          icon={actionButtonIcon}
          iconPlacement="left"
          disabled={actionButtonDisabled}
          onClick={onActionClick}
        />
      ) : null}
    </div>
  )
}
